import React from "react";
import { stringLiterals } from "../data";
import { BASE_URL } from "../state/services/common";
import { Button, Container, Form } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAuthenticated } from "../util";

// Display the landing page with a single button to sign in using JHU SSO.
function Homepage(_props) {
  const token = useSelector((state) => state.auth.token);
  const expiresAt = useSelector((state) => state.auth.expiresAt);

  const handleSubmit = (event) => {
    event.preventDefault();
    window.location.href = `${BASE_URL}/jhu/login`;
  };

  if (isAuthenticated(token, expiresAt)) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <div className="homepage">
      <Container className="content text-center">
        <h1>{stringLiterals.appTitle}</h1>
        <br />
        <br />
        <Form onSubmit={handleSubmit}>
          <Button type="submit" size="lg">
            JHU Single Sign On
          </Button>
        </Form>
      </Container>
    </div>
  );
}

export default Homepage;
